module.exports = __webpack_public_path__ + "85aa15b810b8db98176db0772d8c2a02.pdf";